import './frontend.scss';

// Notification menu localstorage logic
const localStorageRendering = (banner) => {
	// Define the localstorage, notification DOM element dataset ID, close button and the localstorage items
	const { localStorage } = window;
	const { notification } = banner.dataset;
	const closeButton = banner.querySelector('.notification-bar__close');
	const storageItems = localStorage.getItem('notification-bar');

	// Show all notes if localstorage is empty of items
	if (storageItems === null) {
		banner.classList.remove('is-hidden');
	} // If not empty, show items which are NOT icluded in the localstorage items
	else if (!JSON.parse(storageItems).includes(notification)) {
		banner.classList.remove('is-hidden');
	}

	// Append items to storage array
	function appendToStorage(item, keyAndValue) {
		// Check if item already exists in the storage
		let storeData = localStorage.getItem('notification-bar');
		storeData = storeData ? JSON.parse(storeData) : [];
		storeData.push(keyAndValue);
		localStorage.setItem(item, JSON.stringify(storeData));
	}

	// Apply the click event for the notification close button
	closeButton.addEventListener('click', () => {
		// Append notification to the localstorage items as an ID fetched from the DOM element dataset
		appendToStorage('notification-bar', notification);
		banner.classList.add('is-animated');

		// Let the "is-animated" class animation finish before hiding
		setTimeout(() => {
			banner.classList.add('is-hidden');
		}, 300);
	});
};

// Colorize banners based on odd/even index number
// CSS not-selector did not work properly, so has to be applied by JS script
const colorizeBanners = () => {
	const banners = document.querySelectorAll(
		'.notification-bar:not(.is-hidden)'
	);
	banners.forEach((banner, i) => {
		if ((i + 1) % 2 === 1) {
			banner.style.backgroundColor = '#76c';
		} else {
			banner.style.backgroundColor = '#c02eaf';
		}
	});
};

const init = () => {
	// Get the current language from the em block config
	const config = window.emYtkBlocksConfig;
	const currentLang = config.general.pllCurrentLang ?? 'fi';

	// Fetch notifications from the server
	const notificationAjax = `${window.location.origin}/wp-json/ytk/v1/notification/list?lang=${currentLang}`;

	// Get the site notifications container
	const siteNotifications = document.querySelector('.site-notifications');

	// If no notifications container is found, return
	if (!siteNotifications) {
		return;
	}

	// Trying to prevent double initialization by Cookiebot
	if (siteNotifications.classList.contains('is-ready')) {
		return;
	}

	fetch(notificationAjax)
		.then((response) => response.json())
		.then((data) => {
			// Add custom class to the site notifications container when ready
			if (data) {
				siteNotifications.classList.add('is-ready');
			}

			// If notifications are found, loop through them and append to the DOM
			if (data.length) {
				data.forEach((notification) => {
					let notificationLink = '';

					if (notification.link.url) {
						notificationLink = `<a class="notification-bar__link" href="${
							notification.link.url
						}"${notification.link.target && " target='_blank'"}>${
							notification.link.title
						}</a>`;
					}

					const notificationContent = `
						<div class="notification-bar is-hidden" data-notification=${notification.hash}>
							<div class="notification-bar__container">
								<div class="notification-bar__content">
									<img src="/wp-content/themes/ytk/assets/img/icon-alert.svg" alt="" aria-hidden="true" />
									<p class="notification-bar__text">
										<span class="screen-reader-text">${config.text.notificationDesc}:&nbsp;</span>
										${notification.text}
										${notificationLink}
									</p>
								</div>
							</div>
							<button class="notification-bar__close" title="${config.text.notificationClose}">
								<img src="/wp-content/themes/ytk/assets/img/icon-close.svg" alt="" aria-hidden="true" />
							</button>
						</div>
					`;

					siteNotifications.innerHTML += notificationContent;
				});

				// Apply the conditional localstorage rendering for each notification banner
				const notificationBanners =
					document.querySelectorAll('.notification-bar');

				if (notificationBanners.length) {
					notificationBanners.forEach((banner) => {
						localStorageRendering(banner);

						// Add custom class to body if notifications are present and at least one is not hidden
						if (!banner.classList.contains('is-hidden')) {
							document.body.classList.add(
								'has-notification-banner'
							);
						}
					});

					colorizeBanners();
				}
			}
		})
		.catch((error) => console.error('Error:', error)); // eslint-disable-line no-console
};

document.addEventListener('DOMContentLoaded', init);
